export const vmActions = {
  GET_VM_SERVICE_INSTANCES: 'GET_VM_SERVICE_INSTANCES',
  GET_VM_DISK_UTILITY: 'GET_VM_DISK_UTILITY',
  GET_VM_CARD_DETAILS: 'GET_VM_CARD_DETAILS',
  GET_VM_CARD_COUNT: 'GET_VM_CARD_COUNT',
  GET_VM_APP_POOL_EVENTS: 'GET_VM_APP_POOL_EVENTS',
  GET_VM_PROCESS_CPU_DATA: 'GET_VM_PROCESS_CPU_DATA',
  GET_VM_PROCESS_RAM_DATA: 'GET_VM_PROCESS_RAM_DATA',
};
export const vmMutations = {
  SET_CURRENT_VM_INSTANCE: 'SET_CURRENT_VM_INSTANCE',
  SET_CURRENT_VM: 'SET_CURRENT_VM',
  SET_CURRENT_SUBTYPE: 'SET_CURRENT_SUBTYPE',
  SET_CURRENT_VM_SERVICE: 'SET_CURRENT_VM_SERVICE',
};
export const vmGetters = {
  GET_VM_ATTRIBUTES: 'GET_VM_ATTRIBUTES',
  GET_VM_ISACTIVE: 'GET_VM_ISACTIVE',
  GET_VM_AVAILABILITY: 'GET_VM_AVAILABILITY'
};

export const VMMetricType = {
  READ_METRICS_VALUE: 'readMetricsValue',
  READ_LABELED_METRICS_VALUES: 'readLabelledMetricsValue',
  READ_METRICS_LABEL_COUNT: 'readMetricsLabelCount',
  READ_LABELED_METRICS_LATEST_VALUE: 'readLabeledMetricsLatestValue'
};
//TODO: Use these everywhere else
export const VMMetricNames = {
  DISK_UTILITY_TOTAL_BYTES: 'windows_vm_disk_utility_total_bytes',
  DISK_UTILITY_USED_BYTES: 'windows_vm_disk_utility_used_bytes',
  DISK_UTILITY_AVAILABLE_BYTES: 'windows_vm_disk_utility_available_bytes',
  CARD_MEMORY_USAGE_USED_BYTES: 'windows_vm_memory_usage_used_bytes',
  CARD_SWAP_USAGE_PERCENTAGE: 'windows_vm_swap_usage_percentage',
  CARD_SWAP_MEMORY_READ_PERCENTAGE: 'windows_vm_swap_memory_read_percentage',
  CARD_SWAP_MEMORY_WRITE_PERCENTAGE: 'windows_vm_swap_memory_write_percentage',
  CARD_APPLICATION_POOL_DEPLOYED_COUNT:
    'windows_vm_application_pools_deployed_count',
  CARD_IS_ACTIVE: 'isActive',
  CARD_CPU_PERCENTAGE: 'windows_vm_cpu_usage_percentage',
  CARD_ARCHITECTURE: 'architecture',
  CARD_OS_VERSION: 'os_version',
  CARD_HOST_NAME: 'hostname',
  APP_POOL_EVENTS: 'windows_vm_application_pool_events_status',
  PROCESS_CPU_USAGE: 'meter_vm_process_cpu_usage',
  PROCESS_RAM_USAGE: 'meter_vm_process_ram_usage',
};

export const WindowsMetaProperties = [
					{
						key: 'hostname',
						value: 'metaProperty2'
					},
					{
						key: 'architecture',
						value: 'metaProperty3'
					},
					{
						key: 'os_version',
						value: 'metaProperty4'
					},
					{
						key: 'cores',
						value: 'metaProperty5'
					}
				];

export const LinuxMetaProperties = [
  {
    key: 'hostname',
    value: 'metaProperty2'
  },
  {
    key: 'architecture',
    value: 'metaProperty4'
  },
  {
    key: 'os_version',
    value: 'metaProperty5'
  },
  {
    key: 'osName',
    value: 'metaProperty7'
  },
  {
    key: 'cores',
    value: 'metaProperty8'
  }
];